import React, { useEffect, useRef } from "react";
import { useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router";
import { USER_NFTS } from "../constants/urls";
import Navbar from "../components/desktop/Navbar";
import VideoCard from "../components/desktop/VideoCard";
import NFTNav from "../components/NavComponents/NFTNav";
import {getNFTBalance, getTokenOfOwnerByIndex, getTokenURI} from '../utils/chainUtils';
import Card from "../components/desktop/Card";
import TransferManagerComponent from "../components/TransferComponents/TransferManagerComponent";
import { createClient } from 'urql'
import { getLoginInformation} from '../utils/loginHelper';

import LoginButtonsComponent from '../components/desktop/CardComponents/LoginButtonsComponent';
import {fetchOwnedNFTs} from '../utils/backendUtils'
import EarlyAccessFooter from "../components/desktop/EarlyAccessFooter";
import opensea from '../assets/opensea.svg';
import link from '../assets/link.svg';
import opensea_link from '../assets/opensea_link.svg';
import chest_closed from '../assets/chest_closed.png';


const CoinGecko = require('coingecko-api');
const CoinGeckoClient = new CoinGecko();

const url = window.location;
let domain = (new URL(url));
domain = domain.origin;

const Mobile = styled.div`
  display: none;
  @media only screen and (max-device-width: 480px) {
  display: flex;
  flex-direction: column;
  /* height: 100vh; */
  }
`;

const Wrapper = styled.div`
  display: none;
  /* @media (min-device-width: 481px) { */
  display: flex;
  flex-direction: column;
  /* } */
`;

const Desktop = styled.div`
  display: none;
  @media (min-device-width: 481px) {
  display: flex;
  flex-direction: column;
  }
`;



const Container = styled.div`
  padding: 12px 120px;
  display: flex;
  flex-direction: row;
  /* overflow: hidden;
  height: 100vh; */
  @media only screen and (max-device-width: 480px) {
  padding: 12px 27px;
  }
`;

const Title = styled.span`
  font-family: 'IBM Plex Mono';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 90.1%;
  /* or 22px */

  display: flex;
  align-items: center;
  text-transform: uppercase;

  color: #FFFFFF;
  margin-top: 30px;
  padding: 12px 27px;
  @media (min-device-width: 481px) {
  padding: 12px 120px;
  display: none;
  }
`;

const TransferButtonDiv = styled.div`
  width: 83px;
  height: 100%;
  background: #FFFFFF;
  cursor:pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  margin-left: 20px;
  align-items: center;
  text-align: center; 
`

const TransferButtonTextSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  color: #000000;
  padding: 4px 12px;
`;

// const CardWrapper = styled.span`
//     width: 100%;
//     @media (min-device-width: 481px) {
//         width: 275px;
//     }
// `;

const CardWrapper = styled.span`
  width: 100%;
  margin: 16px 0px;
  height: 345px;
  /* width: 245px; */
  @media (min-device-width: 481px) {
  width: auto;
  margin: 10px;
  height: 245px
  }
`;

const Tags = styled.div`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  padding: 9px;
  color: #FFFFFF;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  margin-left: 16px;
  display: flex;
  @media only screen and (max-device-width: 480px) {
  margin-right: 16px;
  margin-left: 0px;
  margin-top: 16px;
  }

`;

const Username = styled.div`
  font-family: 'IBM Plex Mono';
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 90.1%;
  /* identical to box height, or 27px */

  display: flex;
  align-items: center;
  text-transform: uppercase;

  color: #FFFFFF;
  padding: 12px 27px;
  margin-top: 20px;
`;

const OpenButton = styled.div`
  /* Linear */
  background: linear-gradient(95.39deg, #001AFF 3.78%, #DB00FF 100%);
  border-radius: 12px;
  color: #fff;
  display: flex;
  justify-content: center;
  padding: 13px;
`;

const UseButton = styled.div`
  /* Linear */
  background: rgba(255,255,255,0.08);
  border-radius: 12px;
  color: #fff;
  display: flex;
  justify-content: center;
  padding: 13px;
`;

const UsedButton = styled.div`
  /* Linear */
  background: transparent;
  border-radius: 12px;
  border: 1px solid #232323;
  color: #fff;
  display: flex;
  justify-content: center;
  padding: 13px;
`;

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        background: "rgba(21, 21, 29, 1)",
        borderWidth: 0,
        padding: "62px 62px",
        height: "214px",
        width: "340px",
        display: "flex",
        justifyContent: "space-evenly",
        flexDirection: "column",
        alignItems: "center",
    },
};

const CtaButton = ({ count, img }) => {
    return (
        <a
            onClick={() => {
                setOpen(true);
                console.log(open);
            }}
            style={{ textAlign: "center" }}
        >
            <img src={img} />
            <div style={{ textAlign: "center", marginBottom: 16 }}>{count}</div>
        </a>
    );
};

export default function UserPage(props) {
    const [data, dataSet] = useState();
    const [passes, setPasses] = useState();
    const [creators, setCreators] = useState();
    const [modalOpen, setModalOpen] = useState(false);
    const [activeItem, setActiveItem] = useState();
    const [activeItemType, setActiveItemType] = useState();
    
    const [addresses, setAddress] = useState('');
    const [tokenIds, setTokenIds] = useState([]);
    const [maticPrice, setMaticPrice] = useState(0);
    
    const [user, setUser] = useState({});

    let { address } = useParams();
    // Changes to handle /profile url page change
    if(address == undefined) {
        let loginData = getLoginInformation();
        if(loginData){
            address = loginData.user.username;
        }
    }

    const openTransferModal =  (ev, item, itemType) => {
        setModalOpen(true);
        setActiveItem(item)
        setActiveItemType(itemType)
        ev.stopPropagation();
        ev.preventDefault();
    }
    
    const handleModalCloseEvent  = () => {
        setModalOpen(false);
    }

    useEffect(() => {
        async function fetchMyAPI() {
            let ownedNFTs = await fetchOwnedNFTs(address)
            console.log('ownedNFTs', ownedNFTs);
            return ownedNFTs;            
        }
        (async () => {   
            let dd = await fetchMyAPI();
            dataSet(dd.data.videos);
            setPasses(dd.data.passes);
            setCreators(dd.data.creators);
            // setPasses([1,2,3]);
        })()
    }, []);
    
    useEffect(()=>{
        let loginData = getLoginInformation();
        if(loginData){
            setUser(loginData.user);
        }    
    },[])

    useEffect(() => {
        if(user && data && data.length > 0) {
            window.analytics.track('owned_page_visit', {
                type: 'web',
                from: 'owned_page',
                self: (address === user.username),
                owned: data.length
            });
        }
    }, [user, data]);


    const openLoot = (id) => {

    }

    const useLoot = (id) => {
        
    }

    const viewLoot = (id) => {
        
    }

    if (!data || !passes || !creators) {
        return <></>;
    }
    // if (!data) {
    //     return <></>;
    // }
    const desktop_list = data.map((item, index) => {
        return (
            <div style={{
                width: '100%',
                maxWidth: 275,
                margin: '24px 12px',
            }}>
            <CardWrapper key={`list-${index}`} style={{
                display: 'flex',
                flexDirection: 'column',
                margin: '10px 0px',
                alignItems: 'center',                                    
                height: 259,
                width: '100%',
                borderRadius: 12,
                border: '1px solid #232323',                
            }}>
            <a style={{width: '100%'}} href={`${domain}/u/` + item.metadata.attributes[0].value + '/' + item.metadata.attributes[2].value} target='_blank'>
            <div style={{
                // backgroundImage: `linear-gradient(127.32deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 42.82%), url('${chest_closed}')`,
                width: '100%',
                // height: 157,
                backgroundRepeat: 'no-repeat',
                backgroundSize: '100% 100%',
                borderTopRightRadius: 12,
                borderTopLeftRadius: 12
            }}>                  
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                paddingLeft: 10
            }}>
            <span style={{
                fontSize: 32,
                textShadow: '0px 4px 20px rgba(0, 0, 0, 0.4)',
                fontWeight: 'bold',
                fontFamily: 'Space Mono',
            }}>#{item.metadata.attributes[2].value}</span>                                                
            </div>        
            </div>
            </a>
            <div style={{
                backgroundImage: `linear-gradient(127.32deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 42.82%), url('${chest_closed}')`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: '100% 100%',
                height: 174,
                width: '100%',
            }}>

            </div>
            <div style={{justifyContent: 'space-between', display: 'flex', background: 'transparent', width: '100%'}}>
            <div style={{display: 'flex',
                         flexDirection: 'column',
                         justifyContent: 'center',
                         alignItems: 'flex-start', marginLeft: 12,
                         marginTop: 10, marginBottom: 10}}>
            <span style={{fontSize: 11, opacity: 0.4}}>Sold for</span>
            <div  style={{fontSize: 14, fontWeight: 500, marginTop: 2}}>${item.mintedPrice}</div>
            </div>
            <div style={{display: 'flex',
                         flexDirection: 'column',
                         justifyContent: 'center',
                         alignItems: 'flex-start', marginLeft: 12, marginRight: 12,
                         marginTop: 10, marginBottom: 10}}>
            <span style={{fontSize: 11, opacity: 0.4}}>Creator</span>
            <a 
            href={`${domain}/u/` + item.metadata.attributes[0].value}
            style={{fontSize: 14, fontWeight: 500, marginTop: 2}}
            onClick={() => {
                window.analytics.track('creator_username_clicked', {
                    type: 'web',
                    from: 'Owned page card',
                    location: window.location.href
                });
            }}
            >
            {item.metadata.attributes[0].value}
            </a>
            </div>
            {(!item.isClaimed && item.mintedToGlipUserId===user._id) && (
                // {true && (
                <TransferButtonDiv onClick={(e)=>{openTransferModal(
                    e, item, 'video')}}>
                    <TransferButtonTextSpan>
                        TRANSFER
                    </TransferButtonTextSpan>
                </TransferButtonDiv>
            )}
            {(item.isClaimed && item.mintedToGlipUserId===user._id) && (
                <TransferButtonDiv style={{
                    background: 'greenyellow',
                    cursor: 'not-allowed'
                }}>
                    <TransferButtonTextSpan>
                        MOVED
                    </TransferButtonTextSpan>
                </TransferButtonDiv>
            )}
            {(item.mintedToGlipUserId != user._id) && (
                <></>
            )}
            </div>
                </CardWrapper>
                {/* {true && <OpenButton onClick={() => openLoot(item.id)} style={{marginTop: 8}}>OPEN LOOTBOX</OpenButton>}
                    {false && <UseButton onClick={() => useLoot(item.id)} style={{marginTop: 8}}>USE LOOT</UseButton>}
                    {false && <UsedButton onClick={() => viewLoot(item.id)} style={{marginTop: 8}}>ALL LOOT USED</UsedButton>} */}
            </div>
        );
    });


    // const pass_list = passes.map((item, index) => {
    //     return (
    //         <CardWrapper key={`list-${index}`} style={{
    //             display: 'flex',
    //             flexDirection: 'column',
    //             margin: '10px 0px',
    //             alignItems: 'center',
    //             margin: '24px 12px',
    //             height: 214,
    //             border: '1px solid rgba(38, 38, 38, 1)',
    //             borderRadius: 12,
    //             position: 'relative'
    //         }}>
    //             <video 
    //                 src={'https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/video/draft170_4.mp4'}
    //                 style={{position: 'absolute',  bottom: -32, zIndex: -1, width: 273}} autoPlay loop
    //             />
    //             {/* <a style={{width: '100%'}} href={`${domain}/u/` + item.metadata.attributes[0].value + '/' + item.metadata.attributes[2].value} target='_blank'> */}
    //             <a style={{width: '100%'}} target='_blank'>
    //                 <div style={{
    //                     // backgroundImage: `linear-gradient(127.32deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 42.82%), url('${item.imageUri}')`,
    //                     height: 177,
    //                     backgroundRepeat: 'no-repeat',
    //                     backgroundSize: '100% 100%',
    //                 }}>                  
    //                     <div style={{
    //                         display: 'flex',
    //                         justifyContent: 'space-between',
    //                         alignItems: 'flex-start',
    //                         paddingLeft: 10
    //                     }}>
    //                         <span style={{
    //                             fontSize: 26,
    //                             textShadow: '0px 4px 20px rgba(0, 0, 0, 0.4)',
    //                             fontWeight: 'bold',
    //                             fontFamily: 'Space Mono',
    //                             textAlign: 'left',
    //                             lineHeight: 1,
    //                             margin: 8,
    //                         }}>{creators[item.creatorUserId].username}'s<br></br>Lootbox</span>                                                
    //                     </div>        
    //                 </div>
    //             </a>
    //             <div style={{justifyContent: 'space-between', display: 'flex', background: 'rgba(19, 19, 19, 1)', width: '100%', borderBottomLeftRadius: 12, borderBottomRightRadius: 12}}>
    //                 <div style={{display: 'flex',
    //                              flexDirection: 'column',
    //                              justifyContent: 'center',
    //                              alignItems: 'flex-start', marginLeft: 12,
    //                              marginTop: 10, marginBottom: 10}}>
    //                     {/* <span style={{fontSize: 11, opacity: 0.4}}>Sold for</span> */}
    //                     <a href={item.opensea} target="_blank" style={{fontSize: 14, fontWeight: 500, marginTop: 2}}>OpenSea Link</a>
    //                 </div>
    //                 <div style={{display: 'flex',
    //                              flexDirection: 'column',
    //                              justifyContent: 'center',
    //                              alignItems: 'flex-start', marginLeft: 12, marginRight: 12,
    //                              marginTop: 10, marginBottom: 10}}>
    //                     <span style={{fontSize: 11, opacity: 0.4}}>Creator</span>
    //                     <a 
    //                         href={`${domain}/u/` + creators[item.creatorUserId].username}
    //                         style={{fontSize: 14, fontWeight: 500, marginTop: 2}}
    //                         onClick={() => {
    //                             window.analytics.track('creator_username_clicked', {
    //                                 type: 'web',
    //                                 from: 'Owned page card',
    //                                 location: window.location.href
    //                             });
    //                         }}
    //                         >
    //                             {creators[item.creatorUserId].username}
    //                             {/* {item.metadata.attributes[0].value} */}
    //                     </a>
    //                 </div>
    //                 {(!item.isClaimed && item.mintedToGlipUserId===user._id) && (
    //                 //  {true && ( 
    //                     <TransferButtonDiv style={{ borderBottomRightRadius: 12 }} onClick={(e)=>{openTransferModal(
    //                         e, item, 'pass')}}>
    //                         <TransferButtonTextSpan>
    //                             TRANSFER
    //                         </TransferButtonTextSpan>
    //                     </TransferButtonDiv>
    //                 )}
    //                 {(item.isClaimed && item.mintedToGlipUserId===user._id) && (
    //                     <TransferButtonDiv  style={{
    //                         background: 'greenyellow',
    //                         cursor: 'not-allowed',
    //                         borderBottomRightRadius: 12
    //                     }}>
    //                         <TransferButtonTextSpan>
    //                             MOVED
    //                         </TransferButtonTextSpan>
    //                     </TransferButtonDiv>
    //                 )}
    //                 {(item.mintedToGlipUserId != user._id) && (
    //                     <></>
    //                 )}
    //             </div>
    //         </CardWrapper>
    //     );
    // });


    const pass_list = passes.map((item, index) => {
        if(item.imageUri.includes('prime-anniversary'))
            return (
                <CardWrapper className="hover"  key={`list-${index}`} style={{
                    display: 'flex',
                    flexDirection: 'column',
                    // margin: '10px 0px',
                    alignItems: 'center',
                    // margin: '24px 12px',
                    // marginTop: 80,                
                    border: '1px solid rgba(38, 38, 38, 1)',
                    borderRadius: 12,
                    position: 'relative',
                    backgroundImage: `url('${item.videoUri}')`,
                    backgroundSize: '100% 100%',
                    display: 'flex',
                    justifyContent: 'flex-end',
                }}>
                
                <div style={{justifyContent: 'space-between', display: 'flex', background: 'rgba(19, 19, 19, 1)', width: '100%', borderBottomLeftRadius: 12, borderBottomRightRadius: 12}}>
                <div style={{display: 'flex',
                             flexDirection: 'column',
                             justifyContent: 'flex-end',
                             alignItems: 'flex-start', marginLeft: 12,
                             marginTop: 10, marginBottom: 10}}>
                {/* <span style={{fontSize: 11, opacity: 0.4}}>Sold for</span> */}
                <a href={item.opensea} target="_blank" style={{fontSize: 14, fontWeight: 500, marginTop: 2, display: 'flex'}}>
                OpenSea
                <img style={{marginLeft: 8}} src={opensea_link} />
                </a>
                </div>
                <div style={{display: 'flex',
                             flexDirection: 'column',
                             justifyContent: 'center',
                             alignItems: 'flex-start', marginLeft: 12, marginRight: 12,
                             marginTop: 10, marginBottom: 10}}>
                <span style={{fontSize: 11, opacity: 0.4}}>Creator</span>
                <a 
                href={`${domain}/u/` + creators[item.creatorUserId].username}
                style={{fontSize: 14, fontWeight: 500, marginTop: 2}}
                onClick={() => {
                    window.analytics.track('creator_username_clicked', {
                        type: 'web',
                        from: 'Owned page card',
                        location: window.location.href
                    });
                }}
                >
                {creators[item.creatorUserId].username}
                {/* {item.metadata.attributes[0].value} */}
                </a>
                </div>
                {(!item.isClaimed && item.mintedToGlipUserId===user._id) && (
                    //  {true && ( 
                    <TransferButtonDiv style={{ borderBottomRightRadius: 12 }} onClick={(e)=>{openTransferModal(
                        e, item, 'pass')}}>
                        <TransferButtonTextSpan>
                            TRANSFER
                        </TransferButtonTextSpan>
                    </TransferButtonDiv>
                )}
                {(item.isClaimed && item.mintedToGlipUserId===user._id) && (
                    <TransferButtonDiv  style={{
                        background: 'greenyellow',
                        cursor: 'not-allowed',
                        borderBottomRightRadius: 12
                    }}>
                        <TransferButtonTextSpan>
                            MOVED
                        </TransferButtonTextSpan>
                    </TransferButtonDiv>
                )}
                {(item.mintedToGlipUserId != user._id) && (
                    <></>
                )}
                {/* </div> */}
                
            </div>
            </CardWrapper>
            );
        else {
            return (
                <CardWrapper key={`list-${index}`} style={{
                    display: 'flex',
                    flexDirection: 'column',
                    margin: '10px 0px',
                    alignItems: 'center',
                    margin: '24px 12px',
                    height: 214,
                    border: '1px solid rgba(38, 38, 38, 1)',
                    borderRadius: 12,
                    position: 'relative'
                }}>
                    <video 
                        src={'https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/video/draft170_4.mp4'}
                        style={{position: 'absolute',  bottom: -32, zIndex: -1, width: 273}} autoPlay loop
                    />
                    {/* <a style={{width: '100%'}} href={`${domain}/u/` + item.metadata.attributes[0].value + '/' + item.metadata.attributes[2].value} target='_blank'> */}
                        <a style={{width: '100%'}} target='_blank'>
                            <div style={{
                                // backgroundImage: `linear-gradient(127.32deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 42.82%), url('${item.imageUri}')`,
                                height: 177,
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: '100% 100%',
                            }}>                  
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-start',
                                    paddingLeft: 10
                                }}>
                                    <span style={{
                                        fontSize: 26,
                                        textShadow: '0px 4px 20px rgba(0, 0, 0, 0.4)',
                                        fontWeight: 'bold',
                                        fontFamily: 'Space Mono',
                                        textAlign: 'left',
                                        lineHeight: 1,
                                        margin: 8,
                                    }}>{creators[item.creatorUserId].username}'s<br></br>Lootbox</span>                                                
                                </div>        
                            </div>
                        </a>
                        <div style={{justifyContent: 'space-between', display: 'flex', background: 'rgba(19, 19, 19, 1)', width: '100%', borderBottomLeftRadius: 12, borderBottomRightRadius: 12}}>
                            <div style={{display: 'flex',
                                         flexDirection: 'column',
                                         justifyContent: 'center',
                                         alignItems: 'flex-start', marginLeft: 12,
                                         marginTop: 10, marginBottom: 10}}>
                                {/* <span style={{fontSize: 11, opacity: 0.4}}>Sold for</span> */}
                                <a href={item.opensea} target="_blank" style={{fontSize: 14, fontWeight: 500, marginTop: 2}}>OpenSea Link</a>
                            </div>
                            <div style={{display: 'flex',
                                         flexDirection: 'column',
                                         justifyContent: 'center',
                                         alignItems: 'flex-start', marginLeft: 12, marginRight: 12,
                                         marginTop: 10, marginBottom: 10}}>
                                <span style={{fontSize: 11, opacity: 0.4}}>Creator</span>
                                <a 
                                    href={`${domain}/u/` + creators[item.creatorUserId].username}
                                    style={{fontSize: 14, fontWeight: 500, marginTop: 2}}
                                    onClick={() => {
                                        window.analytics.track('creator_username_clicked', {
                                            type: 'web',
                                            from: 'Owned page card',
                                            location: window.location.href
                                        });
                                    }}
                                >
                                    {creators[item.creatorUserId].username}
                                    {/* {item.metadata.attributes[0].value} */}
                                </a>
                            </div>
                            {(!item.isClaimed && item.mintedToGlipUserId===user._id) && (
                                //  {true && ( 
                                <TransferButtonDiv style={{ borderBottomRightRadius: 12 }} onClick={(e)=>{openTransferModal(
                                    e, item, 'pass')}}>
                                    <TransferButtonTextSpan>
                                        TRANSFER
                                    </TransferButtonTextSpan>
                                </TransferButtonDiv>
                            )}
                            {(item.isClaimed && item.mintedToGlipUserId===user._id) && (
                                <TransferButtonDiv  style={{
                                    background: 'greenyellow',
                                    cursor: 'not-allowed',
                                    borderBottomRightRadius: 12
                                }}>
                                    <TransferButtonTextSpan>
                                        MOVED
                                    </TransferButtonTextSpan>
                                </TransferButtonDiv>
                            )}
                            {(item.mintedToGlipUserId != user._id) && (
                                <></>
                            )}
                            </div>
                </CardWrapper>
                            );
                            }
                });

                return (
                <>
                    <Wrapper>
                        <NFTNav 
                            activeTab={'NFT'}
		            username={address}
                            showTabs={false}
                            creator={address}
                            ownerPage={true}
                            ownedNFTs={data.length}
                            expanded={false}
                        />
                        <>
                {!address && (
                    <div style={{  margin: 'auto',width:'50%',
                                   marginTop:'90px'
                                   }}>
                        <LoginButtonsComponent>
                        </LoginButtonsComponent>
                    </div>
                )}
                {address && (
                    <>
                        <Desktop style={{flexDirection: 'row', padding: '12px 120px', marginTop: 20}}>
                                <Username style={{margin: 0, padding: 0}}>{address}</Username>
                                <div style={{display: 'flex', padding: '8px 27px'}}>
                                    <Tags  className="hover" onClick={() => {
                                        var dummy = document.createElement("input");

                                        // Add it to the document
                                        document.body.appendChild(dummy);
                                        
                                        // Set its ID
                                        dummy.setAttribute("id", "dummy_id");
                                        
                                        // Output the array into it
                                        document.getElementById("dummy_id").value=window.location.href;
                                        
                                        // Select it
                                        dummy.select();
                                        
                                        // Copy its contents
                                        document.execCommand("copy");
                                        
                                        // Remove it as its not needed anymore
                                        document.body.removeChild(dummy);
                                    }}>
                                        <img src={link} style={{marginRight: 8}} />
                                        Copy Link
                                    </Tags>
                                    {false && <Tags  className="hover" onClick={() => {window.location.href = `https://twitch.tv/${props.username}`;}}>
                                        <img src={opensea} style={{marginRight: 8}} />
                                        OpenSea
                                    </Tags>}
                                </div>
                        </Desktop>
                        <Mobile>
                                <Username>{address}</Username>
                                <div style={{display: 'flex', padding: '0px 27px'}}>
                                    <Tags  className="hover" onClick={() => {
                                        var dummy = document.createElement("input");

                                        // Add it to the document
                                        document.body.appendChild(dummy);
                                        
                                        // Set its ID
                                        dummy.setAttribute("id", "dummy_id");
                                        
                                        // Output the array into it
                                        document.getElementById("dummy_id").value=window.location.href;
                                        
                                        // Select it
                                        dummy.select();
                                        
                                        // Copy its contents
                                        document.execCommand("copy");
                                        
                                        // Remove it as its not needed anymore
                                        document.body.removeChild(dummy);
                                    }}>
                                        <img src={link} style={{marginRight: 8}} />
                                        Copy Link
                                    </Tags>
                                    {false && <Tags  className="hover" onClick={() => {window.location.href = `https://twitch.tv/${props.username}`;}}>
                                        <img src={opensea} style={{marginRight: 8}} />
                                        OpenSea
                                    </Tags>}
                                </div>
                        </Mobile>
                        <Title>MY Items</Title>
                        <Container>                    
                            <div
                                className={"desktop-item-list"}
                                style={{
                                    display: "flex",
                                    flex: 2,
                                    flexDirection: "row",
                                    marginTop: 10,
                                    flexWrap: 'wrap',
                                    marginLeft: -10,
                                    marginRight: -10,
                                }}
                            >
                                {/* {pass_list} */}
                                {desktop_list}
                            </div>
                        </Container>
                        <TransferManagerComponent
                            item={activeItem}
                            itemType={activeItemType}
                            isOpen={modalOpen}
                            handleModalCloseEvent={()=>{handleModalCloseEvent()}}
                        >
                        </TransferManagerComponent>
                    </>
                )}
                        </>
                    </Wrapper>
                </>
                );
}

